import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useDrawer } from "../../context/drawer";
import AddProperties from "../Forms/Properties/AddProperties";
import UpdateProperty from "../Forms/Properties/UpdateProperty";
import AddBlogs from "../Forms/Properties/Blog/AddBlogs";
import UpdateBolgs from "../Forms/Properties/Blog/UpdateBlogs";
import AddReview from "../Forms/Properties/Reviews/AddReview";
import UpdateReview from "../Forms/Properties/Reviews/UpdateReview";

const DrawerComp = () => {
  const { drawerData, toggleDrawer } = useDrawer();
  const [listData, setListData] = useState(null);

  useEffect(() => {
    if (drawerData.value !== null) {
      setListData(drawerData.value);
    }
  }, [drawerData]);
 
  return (
    <>
      <Drawer
        title={drawerData.title}
        placement="right"
        width={500}
        onClose={toggleDrawer}
        open={drawerData.isOpen}
      >
        {drawerData.type === "propertyAdd" && <AddProperties />}
        {drawerData.type === "propertyUpdate" && <UpdateProperty />}
        {drawerData.type === 'blogAdd' && <AddBlogs />}
        {drawerData.type === 'blogEdit' && <UpdateBolgs />}
        {drawerData.type === 'reviewAdd' && <AddReview />}
        {drawerData.type === 'reviewEdit' && <UpdateReview />}

      </Drawer>
    </>
  );
};
export default DrawerComp;
